import { Breadcrumb } from "flowbite-react";

const BreadCrumbs = ({ front, breadcrumbs }) => {
  if (front) {
    return;
  }

  return (
    <div className="relative mb-4 breadcrumbs_section">
      <div className="px-4 mx-auto max-w-app xl:px-0">
        <Breadcrumb aria-label="breadcrumbs_page">
          <Breadcrumb.Item href="/" className="text-nowrap shrink-0">
            Home
          </Breadcrumb.Item>
          {breadcrumbs?.map((breadcrumb, idx) => {
            const name = breadcrumb?.name;
            const slug = breadcrumb?.slug;

            if (breadcrumbs?.length == idx + 1 || !slug) {
              return (
                <Breadcrumb.Item key={name} className="truncate text-nowrap shrink-0">
                  {name}
                </Breadcrumb.Item>
              );
            } 
            return (
              <Breadcrumb.Item href={slug} key={name + "_" + idx} className="truncate text-nowrap shrink-0">
                {name}
              </Breadcrumb.Item>
            );
            
          })}
        </Breadcrumb>
      </div>
    </div>
  );
};

export default BreadCrumbs;
